import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import utilMd5 from '@/js/utils/md5.js';
export default {
  name: 'LoginPage',
  data: function data() {
    var _this = this;

    var that = this;

    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };

    var checkCode = function checkCode(rule, value, callback) {
      var registerId = _this.registerId;
      var registerPhone = _this.registerPhone;

      if (!value) {
        return callback(new Error('验证码不能为空'));
      }

      if (registerId == 0) {
        return callback(new Error('未发送验证码'));
      }

      var toHtData = {};
      toHtData.registerId = registerId;
      toHtData.loginName = registerPhone;
      toHtData.sjNum = value;
      var url = 'login_toCheckRegister.do';

      _this.$axios.post(url, toHtData).then(function (res) {
        var checkState = res.data;

        if (checkState > 0) {
          callback();
        } else {
          return callback(new Error('验证码不正确'));
        }
      }).catch(function (error) {
        return callback(new Error('验证码不正确'));
      });
    };

    return {
      dialogVisible: true,
      loginTitle: that.GLOBAL.defaultProductName,
      // 访问来源 PC:2 或者 H5:3
      visitSource: utils.checkVisitSource(),
      winHeight: window.innerHeight,
      proId: null,
      activeName: '2',
      loginMode: '账号密码登录',
      //条款是否勾选
      agreeClause: true,
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      yzmLoginForm: {
        account: '',
        code: ''
      },
      yzmLoginRules: {
        account: [{
          validator: checkPhone,
          trigger: 'blur'
        }],
        code: [{
          validator: checkCode,
          trigger: 'blur'
        }]
      },
      //发送验证码按钮的文字
      yzmText: "发送验证码",
      //发送验证码按钮的状态
      yzmFlag: false,
      //验证码倒计时
      auth_time: 0,
      //短信验证码的ID
      registerId: 0,
      //短信验证码的手机号
      registerPhone: "",
      domain_name: ""
    };
  },
  created: function created() {
    var that = this; //如果是PC进入登录页面 清除登录信息
    // if(this.ifChild == 0) {

    utils.loginOutClearSession(); // }

    var queryJson = this.$route.query;

    if (queryJson.proId) {
      this.proId = queryJson.proId;
      localStorage.proId = this.proId;
    }

    if (localStorage.domain_name && localStorage.domain_name != "") {
      that.loginTitle = that.GLOBAL.loginProductName[localStorage.domain_name];
    } else {
      that.loginTitle = that.GLOBAL.defaultProductName;
    } //  


    if (utils.isNull(localStorage.proId) && this.proId) {
      localStorage.proId = this.proId;
    }

    var paramsJson = this.$route.params;

    if (paramsJson.domain_name) {
      localStorage.domain_name = paramsJson.domain_name;
      that.domain_name = paramsJson.domain_name;
    } // else {
    //     localStorage.domain_name = "";
    // }
    // pageUtils.setCookie("test","testValue",1);
    // 判断是否是 


    var vueAutoLoginUserName = pageUtils.getCookie("vueAutoLoginUserName");
    console.log("cookieTest=========================", vueAutoLoginUserName);
    var electronCompanyName = pageUtils.getCookie("electronCompanyName");

    if (electronCompanyName == "beijingkewei" && vueAutoLoginUserName && vueAutoLoginUserName != "") {
      if (vueAutoLoginUserName != "admin") {
        this.electronInitLogin(vueAutoLoginUserName);
      }
    } // 判断是否是企业微信登录 如果是 则包含了code和state字段 以及appId字段 进行用户身份信息获取


    if (paramsJson.code && paramsJson.state == "STATE" && paramsJson.appid == "ww1dc17f7e79437d0d") {
      this.toGetWorkChatUserInfo(paramsJson);
    }

    pageUtils.flutterWebPageFinished();
  },
  methods: {
    //切换pc登录方式
    handleClickPC: function handleClickPC(e) {
      console.log(e);

      if (e == '2') {
        this.loginMode = '账号密码登录';
        this.activeName = '1';
      }

      if (e == '1') {
        this.loginMode = '验证码登录';
        this.activeName = '2';
      }
    },
    //切换登录方式
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    submitForm: function submitForm() {
      console.log(this.activeName); // 登录时根据activeName的值判断登录方式 1：验证码登录    2：用户名密码登录

      var that = this;
      var proId = this.proId;
      console.log("proId===========", proId);
      var tmpLoginForm = that.loginForm;

      if (that.activeName == 1) {
        tmpLoginForm = that.yzmLoginForm;
      }

      var userName = tmpLoginForm.account;
      var password = tmpLoginForm.password;
      var yzmCode = tmpLoginForm.code;
      var registerId = that.registerId;
      var formName = "loginForm";

      if (that.activeName == 1) {
        formName = "yzmLoginForm";
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (that.activeName == 1) {
            utils.yzmToHtLoginIn(userName, yzmCode, that, registerId);
          } else {
            utils.toHtLoginIn(userName, password, that);
          }
        }
      });
    },

    /**
      * 发送短信验证码 发送成功后 进行60秒倒计时 60秒后可以重新发送
      */
    sendMsgYzm: function sendMsgYzm() {
      var _this2 = this;

      var that = this;
      var telPhone = this.yzmLoginForm.account;
      this.$refs.yzmLoginForm.validateField('account', function (phoneError) {
        if (!phoneError) {
          _this2.yzmFlag = true;
          var toHtData = {};
          toHtData.telPhone = telPhone;
          toHtData.sentType = 1;
          var url = 'login_registerPhoneMsg.do';

          _this2.$axios.post(url, toHtData).then(function (res) {
            var registerId = res.data;

            if (registerId > 0) {
              that.registerId = registerId;
              that.registerPhone = telPhone;
              _this2.auth_time = 60;

              _this2.getAuthCode();

              that.$message({
                message: "验证码发送成功!",
                type: 'success'
              });
            } else {
              _this2.yzmFlag = false;
              that.$message({
                message: "验证码发送失败,请重试!",
                type: 'error'
              });
            }
          }).catch(function (error) {
            that.yzmFlag = false;
            that.$message({
              message: "发送失败!",
              type: 'error'
            });
          });
        } else {}
      });
    },

    /**
      * 定时器进行秒倒计时
      */
    getAuthCode: function getAuthCode() {
      var _this3 = this;

      if (this.authTimeTimer) {
        clearTimeout(this.authTimeTimer);
      }

      this.authTimeTimer = setTimeout(function () {
        _this3.auth_time -= 1;

        if (_this3.auth_time < 0) {
          _this3.yzmFlag = false;
          _this3.yzmText = "发送验证码";
          clearTimeout(_this3.authTimeTimer);
        } else {
          _this3.yzmText = _this3.auth_time + "后重新发送";

          _this3.getAuthCode();
        }
      }, 1000);
    },
    closeLogin: function closeLogin() {
      // this.$parent.closeLoginDialog();
      this.$emit("closeLoginDialog");
    },

    /**
     * 跳转到注册页面
     */
    toRegister: function toRegister() {
      var that = this;

      if (that.ifChild == 1) {
        // 切换为注册页面
        // this.$parent.changLoginOrLogon();
        // that.$emit("changLoginOrLogon");
        //更改为调用app中的changeLoginOrLogon方法
        console.log("that.$router===============", that.$router);
        that.$router.app.$children[0].changLoginOrLogon();
      } else {
        this.$router.push({
          name: "LogonPage"
        });
      }
    },

    /**
     * 获取企业微信的登录人的信息
     */
    toGetWorkChatUserInfo: function toGetWorkChatUserInfo(json) {
      var that = this;
      var toHtData = {
        code: json.code
      };
      var url = 'login_getWorkChatAccessToken.do?source=1';
      var loading = that.$loading({
        lock: true,
        text: '获取授权信息中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      that.$axios.post(url, toHtData).then(function (res) {
        var errcode = res.data.errcode;
        loading.close();
        console.log("res===========================", res.data);

        if (errcode == 0) {
          var userId = res.data.UserId;
          var yzm = utilMd5.hexMD5(userId + "999999999");
          console.log("yzm===========================", yzm);
          utils.yzmToHtLoginIn(userId, yzm, that, 999999999);
        }
      });
    },

    /** electron中打开 已经登录过自动登录 */
    electronInitLogin: function electronInitLogin(userName) {
      var that = this;
      var yzm = utilMd5.hexMD5(userName + "999999999");
      utils.yzmToHtLoginIn(userName, yzm, that, 999999999);
    }
  },
  props: {
    ifChild: {
      type: Number,
      default: 0
    }
  },
  beforeMount: function beforeMount() {}
};